import { Link } from 'react-router-dom';
import { WorkerApiStatus } from '@/modules/admin/components/WorkerApiStatus';
import { useAuth } from '@/shared/hooks/useAuth';
import { modulePaths } from '@/routes/paths';
import { adminPaths } from '@/routes/paths';

export function AdminHomePage() {
  const { profile, hasPermission } = useAuth();

  return (
    <section>
      <h1>Administración</h1>
      <p className="auth-muted">
        Consola de configuración y accesos — empresa única (
        {profile?.companyId ?? 'default'}).
      </p>

      <ul className="inventory-cards">
        {hasPermission('users.manage') ? (
          <li>
            <Link
              to={`${modulePaths.admin}/${adminPaths.users}`}
              className="inventory-card"
            >
              <strong>Usuarios y accesos</strong>
              <span>
                Aprobar pendientes, asignar roles y activar cuentas (Google y
                email).
              </span>
            </Link>
          </li>
        ) : null}
        {hasPermission('audit.read') ? (
          <li>
            <Link
              to={`${modulePaths.admin}/${adminPaths.audit}`}
              className="inventory-card"
            >
              <strong>Actividad y auditoría</strong>
              <span>
                Historial de cambios, accesos denegados y operaciones
                registradas en el ERP.
              </span>
            </Link>
          </li>
        ) : null}
        <li>
          <WorkerApiStatus />
        </li>
        <li>
          <div className="inventory-card inventory-card--static">
            <strong>Configuración empresa</strong>
            <span>Próxima fase — datos fiscales y preferencias.</span>
          </div>
        </li>
      </ul>
    </section>
  );
}
